import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface DownloadingStatus {
  downloading: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class CarLinerPdfDownloadIndicatorServiceService {
  private downloadingSubject: BehaviorSubject<DownloadingStatus>;

  constructor() {
    this.downloadingSubject = new BehaviorSubject<DownloadingStatus>({ downloading: false, data: null });
  }

  isDownloading(): Observable<DownloadingStatus> {
    return this.downloadingSubject;
  }

  setDownloading(downloading: DownloadingStatus): void {
    this.downloadingSubject.next(downloading);
  }
}
